import { render } from "./Step4.vue?vue&type=template&id=570f2d01"
import script from "./Step4.vue?vue&type=script&lang=ts"
export * from "./Step4.vue?vue&type=script&lang=ts"

import "./Step4.vue?vue&type=style&index=0&id=570f2d01&lang=scss"
script.render = render

export default script